import React from 'react'
import PropTypes from 'prop-types'

import styles from './styles.module.css'

export default class RadioComponents extends React.Component {
  static propTypes = {
    options: PropTypes.array,
    value: PropTypes.string,
    onChange: PropTypes.func,
    className: PropTypes.string
  }

  renderOptions() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'options' does not exist on type 'Readonl... Remove this comment to see the full error message
    return this.props.options.map((option, index) => {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'value' does not exist on type 'Readonly<... Remove this comment to see the full error message
      const selected = this.props.value === option.value
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'onChange' does not exist on type 'Readon... Remove this comment to see the full error message
      const onClick = () => this.props.onChange(option.value)
      return (
        <div key={index} onClick={onClick} className={styles.option}>
          <input className={styles.radio} type="radio" checked={selected} onChange={onClick} />
          <div>{option.children}</div>
        </div>
      )
    })
  }

  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'className' does not exist on type 'Reado... Remove this comment to see the full error message
    return <div className={this.props.className}>{this.renderOptions()}</div>
  }
}
